// docs: https://github.com/altostra/type-validations#readme
import { enumOf, objectOf, maybe } from "@altostra/type-validations";
import { string, boolean, number, any } from "@altostra/type-validations/lib/primitives";

import { isSurveyDefinition } from "@lib/surveys";

export const isEngagementLandingPageDataResult = objectOf({
  id: string,
  landing_page_id: string,
  name: string,
  description: string,
  marked_as_deleted: boolean,
  enabled: boolean,
  last_edited: number,
  last_edited_by: string,
  unpublished_timestamp: maybe(number, true),
  created_by: string,
  status: string,
  site_name: string,
  site_description: string,
  slug: string,
  favicon_url: string,
  favicon_url_is_custom: boolean,
  grapes_js_data: maybe(any, true),
  base_url: string,
  full_url: string,
  html: string,
  has_been_enabled: boolean,
  first_published: maybe(number, true),
  created_at: number,
  size_limit_status: maybe(enumOf("ok", "blocked", "warning"), true),
  size_limit_status_updated_at: maybe(number, true),
  survey_definition: maybe(isSurveyDefinition, true),
});
